import { VariantProps } from "@gluestack-ui/utils";
import React from "react";
import { hstackStyle } from "./HStack.styles";

type IHStackProps = React.ComponentPropsWithoutRef<"div"> & VariantProps<typeof hstackStyle>;

const HStack = React.forwardRef<React.ComponentRef<"div">, IHStackProps>(
	({ className, space, reversed, ...props }, ref) => {
		return <div className={hstackStyle({ space, reversed, class: className })} {...props} ref={ref} />;
	},
);

HStack.displayName = "HStack";

export { HStack };
